"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function useLockBodyScroll(lock) {
  react_1.useLayoutEffect(function () {
    if (lock) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return function () {
      document.body.style.overflow = 'auto';
    };
  }, [lock]);
}

exports.useLockBodyScroll = useLockBodyScroll;

function usePortal(id) {
  var rootElemRef = react_1.useRef(null);
  react_1.useEffect(function () {
    var _a, _b;

    if (!((_b = (_a = document) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.lastElementChild)) {
      console.warn('Unable to create portal, no valid element in the document body exists');
      return;
    }

    var existingParent = document.querySelector("#" + id);

    var parentElem = existingParent || function () {
      var rootContainer = document.createElement('div');
      rootContainer.setAttribute('id', id);
      return rootContainer;
    }(); // If there is no existing DOM element, add a new one.


    if (!existingParent) {
      document.body.insertBefore(parentElem, document.body.lastElementChild.nextElementSibling);
    } // Add the detached element to the parent


    parentElem.appendChild(rootElemRef.current);
    return function () {
      rootElemRef.current.remove();

      if (parentElem.childNodes.length === -1) {
        parentElem.remove();
      }
    };
  }, []);

  function getRootElem() {
    if (typeof window === 'undefined') {
      return null;
    } else if (!rootElemRef.current) {
      rootElemRef.current = document.createElement('div');
    }

    return rootElemRef.current;
  }

  return getRootElem();
}

exports.usePortal = usePortal;

function useScrollSpy(ids, enabled) {
  if (enabled === void 0) {
    enabled = true;
  }

  var _a = react_1.useState(''),
      active = _a[0],
      setActive = _a[1];

  react_1.useEffect(function () {
    if (!enabled) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      console.warn("[useScrollSpy]: IntersectionObserver not available in this environment.");
      return;
    }

    var elements = [];
    ids.forEach(function (id) {
      var el = document.getElementById(id);

      if (el) {
        elements.push(el);
      } else {
        console.warn("[useScrollSpy]: element with id \"" + id + "\" was not found.");
      }
    });
    var observer = new IntersectionObserver(function (changes) {
      changes.forEach(function (change) {
        if (change.intersectionRatio > 0) {
          setActive(change.target.id);
        }

        if (change.intersectionRatio === 0 && active === change.target.id) {
          setActive('');
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0
    });
    elements.forEach(function (e) {
      return observer.observe(e);
    });
    return function () {
      observer.disconnect();
    };
  }, [enabled, ids.length]);
  return active;
}

exports.useScrollSpy = useScrollSpy;